import PropTypes from 'prop-types'
import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import { CARD_NAME_MAX_LENGTH } from 'const/limits'
import {
  FormGroup,
  ControlLabel,
  HelpBlock,
  Button
} from 'react-bootstrap'
import Textarea from 'components/Textarea'

export class TemplateCardForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  }

  constructor (props) {
    super(props)

    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.renderField = this.renderField.bind(this)
  }

  handleKeyDown (event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.props.handleSubmit()
    }
  }

  renderField (field) {
    return (
      <FormGroup
        validationState={field.meta.touched && field.meta.error ? 'error' : null}
      >
        <ControlLabel><FormattedMessage id='NAME' /></ControlLabel>
        <Textarea
          {...field.input}
          name={null}
          maxLength={CARD_NAME_MAX_LENGTH}
          onKeyDown={this.handleKeyDown}
        />
        {field.meta.touched && field.meta.error && <HelpBlock>{field.meta.error}</HelpBlock>}
      </FormGroup>
    )
  }

  render () {
    const { handleSubmit, submitting } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <Field
          name='name'
          component={this.renderField}
        />
        <Button type='submit' bsStyle='primary' disabled={submitting}>
          <FormattedMessage id='CARD_TEMPLATE_BUTTON' />
        </Button>
      </form>
    )
  }
}

export default reduxForm({
  form: 'templateCardForm'
})(TemplateCardForm)
